interface ValidationSectionProps {
  isValidating: boolean;
  onValidate: () => void;
}

function ValidationSection({ isValidating, onValidate }: ValidationSectionProps): JSX.Element {
  return (
    <section className="App-section">
      <div className="App-section-header">
        <h2 className="App-section-title">Transaction Validation</h2>
        <p className="App-section-description">Review and validate your uploaded payment data</p>
      </div>
      <div className="App-validation-container">
        <button
          className="App-validate-button"
          disabled={isValidating}
          onClick={onValidate}
        >
          <span className="App-button-icon">
            {isValidating ? '⏳' : '🔍'}
          </span>
          <span className="App-button-text">
            {isValidating ? 'Running Rule Set...' : 'Run Rule Set'}
          </span>
        </button>
      </div>
    </section>
  );
}

export default ValidationSection;

